"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Spinner_1 = __importDefault(require("@opsbase/web-ui/Spinner"));
const react_1 = __importDefault(require("react"));
const useView_1 = __importDefault(require("../useView"));
function ViewSpinner({ viewId, children }) {
    const view = (0, useView_1.default)(viewId);
    return react_1.default.createElement(Spinner_1.default, { busy: !view }, !!view && children);
}
exports.default = ViewSpinner;
